module.exports = __webpack_public_path__ + "static/media/more-01.e6052ece.svg";